<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    v-if="isSidebarActiveLocal"
    ref="frame"
    :class="isSidebarActiveLocal ? 'active' : ''" class="product-pop-cont">
    <div ref="result"></div>
    <div class="pop-frame" tabindex="1">
      <div class="pop-top">
        <h4>Restaurant Sale Contact Form</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer text-black"></feather-icon>
      </div>
      <div class="pop-main">
        <div class="claim-top claim-form">
          <h2>Please share your information</h2>
          <p>
            Please share your contact information with us to receive information about the restaurant.
          </p>
          <div class="request-form">
            <span v-show="form_check && !validateName" class="text-danger">The Business Name field is required</span>

            <input type="text"
                   v-validate="'required'"
                   name="Name"
                   placeholder="Name" v-model="name"/>

            <span v-show="errors.has('Name')" class="text-danger">{{ errors.first('Name') }}</span>

            <input type="email"
                   v-validate="'required'"
                   name="Email Address"
                   placeholder="Email Address" v-model="email" />
            <span v-show="errors.has('Email Address')" class="text-danger">{{ errors.first('Email Address') }}</span>

            <phone-mask-input
              v-model="mobileNum"
              autoDetectCountry
              showFlag
              @onValidate="onValidate"
              wrapperClass="relative"
              inputClass="tr-form-control vs-input-no-border py-4 px-2 mt-4 mb-0"
              flagClass="phone-flag"
              v-validate="'required'"
              name="Phone Number"
            />
            <span v-show="form_check && !validatePhone" class="text-danger">Phone Number field is required</span>

            <vs-textarea
                placeholder="Description"
                v-validate="'required'"
                data-vv-as="Description"
                name="Description"
                id="Description"
                v-model="description"
                class="tr-form-control vs-input-no-border vs-input-no-border py-4 px-2 mt-4 mb-0" />
            <span v-show="errors.has('Description')" class="text-danger">{{ errors.first('Description') }}</span>
          </div>
        </div>
      </div>
      <div class="pop-footer justify-end">
        <div class="claim-button" @click="submitData">Send Request</div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneMaskInput from 'vue-phone-mask-input'
export default {
  name: 'RestaurantSignupPopup',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    restaurantSaleId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      mobileNum: '',
      name: '',
      description: '',
      email: '',
      form_check: false,
      placeService: null,
      postcode: '',
      city: '',
      state: '',
      country: ''
    }
  },
  components: {
    PhoneMaskInput
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.resetForm()
        }
      }
    },
    validatePhone () {
      return this.mobileNum.length >= 12
    },
    validateName () {
      return this.name.length > 0
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onValidate () {
    },
    resetForm () {
      this.errors.clear()
    },
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    submitData () {
      this.form_check = true
      this.$validator.validateAll().then(result => {
        if (result && this.validateName && this.validatePhone) {
          this.$vs.loading()
          const payload = {
            name: this.name,
            description: this.description,
            email: this.email,
            phone: this.mobileNum,
            restaurantSaleId: this.restaurantSaleId
          }
          this.$store.dispatch('api/sendRestaurantSale', payload)
            .then(result => {
              if (result) {
                this.$vs.notify({
                  title: 'Success',
                  text: 'Email sent successfully',
                  color: 'success',
                  iconPack: 'feather',
                  icon: 'icon-check'
                })
                this.$vs.loading.close()
                this.form_check = false
                this.isSidebarActiveLocal = false
              }
            })
            .catch(error => {
              this.$vs.loading.close()
              this.$vs.notify({
                title: 'Error',
                text: error.message,
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            })
        }
      }).catch(() => {
        this.form_check = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.claim-button{
  padding:10px 15px;
  width:max-content;
  border-radius: 7px;
  background-color:#f24405;
  color:#fff;
  font-weight: 600;
  cursor:pointer;
  &:hover{
    background-color:#e23f04;
  }
}
.phone-mask {
  width:100%;
  padding:15px 10px 15px 10px !important;
  border:1px solid #ccc;
  border-radius: 7px;
  margin-bottom:15px;
}
.claim-form {
  padding: 20px 10px;
  input {
    width:100%;
    padding:15px 10px 15px 10px !important;
    border:1px solid #ccc;
    border-radius: 7px;
    margin-top:15px;
  }
  h2{
    font-weight: 900;
  }
  p {
    margin-top:20px;
  }
  .autocomplete-items {
    top: 100%;
  }
}
.product-pop-cont.active {
  display:flex;
}
.product-pop-cont {
  position:fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width:100%;
  height:100vh;
  z-index: 45000;
  display: none;
  justify-content: center;
  align-items:center;
  background-color:rgba(0,0,0,.35);
  * {
    box-sizing: border-box;
  }
}
.pop-product-image {
  width:100%;
  height:250px;
  background-position: center;
  background-size:cover;
}
.pop-frame{
  position:relative;
  background-color:#fff;
  width:600px;
  min-height:400px;
  max-height:80vh;
  padding:0px 10px 0px 10px;
  border-radius: 7px;
}
.pop-top{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:20px;
  height:50px;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  background:#fff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, .2);
  z-index:1;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.pop-footer{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:20px;
  position:absolute;
  bottom:0;
  left:0;
  width:100%;
  background:#fff;
  box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, .2);
  z-index: 999;
  border-bottom-right-radius: 7px;
  border-bottom-left-radius: 7px;
}
.pop-main {
  padding:60px 0 90px 0;
  max-height: calc(80vh - 170px);
  overflow:scroll;
}
.pop-main::-webkit-scrollbar{
  display:none;
}
.pop-add-button{
  display:flex;
  background-color:#0070eb;
  color:#fff;
  font-weight: bold;
  padding:10px;
  cursor:pointer;
  font-size:14px;
  justify-content: center;
  align-items: center;
  width:50%;
  border-radius: 7px;
}
.pop-add-item{
  width:100%;
  text-align: center;
}
.pop-quantity{
  width:50%;
  padding-right:20px
}
.quantity-button{
  border:1px solid #ccc;
  width:100%;
  height:36px;
  border-radius: 7px;
  button{
    &:first-child{
      border-top-left-radius:7px;
      border-bottom-left-radius:7px;
    }
    &:last-child{
      border-top-right-radius:7px;
      border-bottom-right-radius:7px;
    }
    width:30%;
    border:none;
    background-color:#f2f2f2;
    height: 100%;
    margin:0;
    text-align:center;
    font-size:22px;
    &:active{
      background-color:#0070eb;
      color:#fff;
    }
  }
  input{
    width:40%;
    border:none;
    text-align: center;
    font-size:22px;
  }
}
.pop-product-name{
  span{
    margin-bottom:20px;
  }
  h2{
    margin-bottom:20px;
  }
  margin-top:20px;
  margin-bottom:20px;
}
.claim-features{
  span{
    font-weight: 900;
    color:#13aa37;
  }
  li {
    font-weight: 500;
    font-style: italic;
    display: inline-block;
    margin-right:20px;
  }
}
@media (max-width:768px) {
  .product-pop-cont{
    padding:20px;
  }
  .claim-button{
    width:100%;
    text-align: center;
  }
  .claim-form {
    h2{
      font-size:16px;
      text-align: center;
    }
  }
  .pop-main {
  padding:60px 0 0px 0;
  max-height: calc(80vh - 120px);
}
}
</style>
